import { SlideOver } from "../../components/core";
import { Button } from "@frontend/lyng/button";
import ThankYouLeaves from "../../assets/thank-you-leaves.svg?react";
import { useTranslate } from "@tolgee/react";

interface ShiftThankYouSlideOverProps {
  onClose: () => void;
}

const ShiftThankYouSlideOver = ({ onClose }: ShiftThankYouSlideOverProps) => {
  const { t } = useTranslate();
  return (
    <SlideOver onClose={onClose}>
      <div className="relative flex flex-col h-full w-full bg-secondary-900 rounded-3xl overflow-hidden">
        <div className="absolute right-0 top-8 flex flex-col items-end z-10 pr-8">
          <ThankYouLeaves className="w-36 h-36" />
        </div>
        <div className="flex flex-col justify-start items-start h-full pt-48 pl-6 z-20">
          <span className="text-white text-3xl font-bold font-poppins">
            {t("shiftThankYou.title")}
          </span>
        </div>
        <div className="absolute bottom-8 w-full flex justify-center z-30">
          <Button
            type="button"
            variant="tertiary"
            size="lg"
            text={t("close")}
            onClick={onClose}
          />
        </div>
      </div>
    </SlideOver>
  );
};

export default ShiftThankYouSlideOver;
